import React, { Fragment, useEffect, useState } from "react";

import { Dropdown } from "@components/General/Dropdown/dropdown.component";
import { DropdownItem } from "@components/General/Dropdown/dropdownItem.component";

type Props = {
    handleChange: (newQuantity: number, oldQuantity: number) => void;
    roundingValue: number | undefined;
    minimumOrderQuantity: number;
    maximumOrderQuantity: number;
    isUpdatingCart: boolean;
    value: number;
};

const AmountDropDown = ({
    handleChange,
    roundingValue,
    minimumOrderQuantity,
    maximumOrderQuantity,
    isUpdatingCart,
    value,
}: Props) => {
    const options = [];
    const [quantity, setQuantity] = useState(0);

    useEffect(() => {
        setQuantity(value);
    }, []);

    useEffect(() => {
        if (!isUpdatingCart && value !== quantity) {
            setQuantity(value);
        }
    }, [value, isUpdatingCart]);

    for (
        let i = minimumOrderQuantity;
        i < maximumOrderQuantity;
        i += roundingValue ? roundingValue : 0
    ) {
        options.push(i);
    }

    const onOptionClick = (option: number) => {
        const oldQuantity = quantity;

        if (isUpdatingCart) {
            return;
        }

        setQuantity(option);
        handleChange(option, oldQuantity);
    };

    return (
        <Fragment>
            <Dropdown
                data-test="deliveryAmount-dropDown"
                placeholder={quantity}
                useLabel={false}
                components={{
                    toggle: {
                        className: "delivery-amount__dropdown",
                        "data-test": "deliveryAmount-dropDown-toggle",
                    },
                    menu: {
                        className: "delivery-amount__dropdownMenu",
                        "data-test": "deliveryAmount-dropDown-menu",
                    },
                }}
            >
                {options.map(option => (
                    <DropdownItem
                        key={option}
                        data-test={`deliveryAmount-dropDown-menu-item-${option}`}
                        onClick={() => {
                            onOptionClick(option);
                        }}
                        label={option}
                    />
                ))}
            </Dropdown>
        </Fragment>
    );
};

export default AmountDropDown;
